import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'

export async function getSingleBookedSessionResponseBySlug(slug) {
  const response = await getDataWithoutParams(`/api/secure/user/booked-slot/details?slug=${slug}`)
  if (response.status === 200 && isCommonResponseSuccessful(response.data?.code)) {
    return response
  }
}
